import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "13",
  height: "13",
  fill: "none",
  viewBox: "0 0 13 13"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "#696986",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M10.667 10.667h-8v-8"
    }, null, -1),
    _createElementVNode("path", {
      stroke: "#696986",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "m2.667 8.917 4-3.75 1.5 1.5 2.25-2.25"
    }, null, -1)
  ]))]))
}
export default { render: render }